const ProductType = {
    GROUP: 'product_group',
    OWN: 'own_product',
    PURCHASED: 'purchased_product',
    PURCHASED_UNDEFINED_SUPPLIER: 'purchased_product_undefined_supplier',
    COMPONENT_TO_PURCHASED_PRODUCT: 'component_to_purchased_product',
    COMPONENT_TO_COMPLEX_PURCHASED_PRODUCT: 'component_to_complex_purchased_product',
    FICTITIOUS: 'fictitious',
    UNDEFINED: 'undefined',

    all() {
        return [
            this.GROUP,
            this.OWN,
            this.PURCHASED,
            this.COMPONENT_TO_PURCHASED_PRODUCT,
        ];
    }
};

const SubstanceState = {
    ALL_UNDEFINED: 'au',
    SOME_DEFINED_INCLUDES_SUBSTANCES: 'sdis',
    SOME_DEFINED_DOES_NOT_INCLUDE_SUBSTANCES: 'sddnis',
    ALL_DEFINED_INCLUDES_SUBSTANCES: 'adis',
    ALL_DEFINED_DOES_NOT_INCLUDE_SUBSTANCES: 'addnis',
};

const SubmissionStatus = {
    QUEUED: 'queued',
    ERROR: 'error',
    NOTIFIED: 'notified',
    ECHA_SERVER_ERROR: 'echa_server_error',
    CHECK_STATUS_ATTEMPTS_EXCEEDED: 'check_status_attempts_exceeded',
    PENDING: 'PENDING',
    UNDER_PROCESSING: 'UNDER_PROCESSING',
    SUCCEEDED: 'VALIDATION_SUCCEEDED',
    FAILED: 'VALIDATION_FAILED',
    UNDEFINED: 'undefined',

    getTranslationKey(status) {
        return 'Component(SubmissionStatusEnum):' + status;
    },
    toArray() {
        return [
            this.QUEUED,
            this.ERROR,
            this.ECHA_SERVER_ERROR,
            this.CHECK_STATUS_ATTEMPTS_EXCEEDED,
            this.PENDING,
            this.UNDER_PROCESSING,
            this.SUCCEEDED,
            this.FAILED
        ];
    }
};

const RequestStatus = {
    REJECTED: 'rejected',
    APPROVED: 'approved_by_questioner',
    PARTIALLY_APPROVED: 'partially_approved_by_questioner',
    REPLIED: 'replied',
    NEW: 'new',
    FORWARDED_TO_SUPPLIER: 'forwarded_to_supplier',
    EXTERNAL_RESPONSE: 'external_response',
    NEW_INFO: 'new_info',

    all() {
        return [
            this.NEW,
            this.APPROVED,
            this.PARTIALLY_APPROVED,
            this.REPLIED,
            this.FORWARDED_TO_SUPPLIER,
            this.REJECTED,
            this.NEW_INFO,
            this.EXTERNAL_RESPONSE
        ];
    }
};

const ConcernElementsInformationOwner = {
    SUPPLIER: 'supplier',
    WE: 'we',
    WE_PARTIALLY: 'we-partially',
};

const DocumentType = {
    VERIFICATION: 'verification',
    DESCRIPTION: 'description'
};

const VerificationDocumentType = {
    DECLARATION_OR_CONFORMITY: 'doc',
    COMPLIANT_STATEMENT: 'compliant_statement',
    EVIDENCE_REPORT: 'evidence',
    SAFE_USE_INSTRUCTIONS: 'safe_use',
    DISSEMBLING_INSTRUCTIONS: 'dissembling',

    all() {
        return [
            this.COMPLIANT_STATEMENT,
            this.DECLARATION_OR_CONFORMITY,
            this.EVIDENCE_REPORT,
            this.SAFE_USE_INSTRUCTIONS,
            this.DISSEMBLING_INSTRUCTIONS,
        ];
    },

    translationKey(type) {
        return 'Component(VerificationDocumentTypeEnum):' + type;
    }
};

const Identifiers = {
    PRODUCT_ID: 'Product ID',
    SUPPLIERS_PRODUCT_ID: 'Supplier’s product ID',
    EAN: 'EAN',
    SCIP_NUMBER: 'SCIP_number',
    SUPPLIERS_SCIP_NUMBER: 'Suppliers SCIP-number',

    PART_NUMBER: 'Part number',
    CATALOGUE_NUMBER: 'Catalogue number',
    GTIN: 'GTIN (Global Trade Item Number)',
    GPC: 'GPC (Universal Product Code)',
    JAN: 'JAN (Japanese Article Number)',
    REFERENCE_NUMBER: 'Reference number',
    OTHER: 'Other',
    UUID: 'UUID',
    UNDEFINED: 'Undefined',
};

const Names = {
    OUR_PRODUCT_NAME: 'Our product name',
    SUPPLIERS_PRODUCT_NAME: 'Supplier’s product name',
    CATALOGUE_NAME: 'Catalogue name',
    MODEL: 'Model',
    BRAND: 'Brand',
    OTHER: 'Other',
    SCIP_NAME: 'SCIP Name'
};

function getNameOrId(collection, key) {
    let val = collection.find(n => n.key === key);

    return val ? val.value : '';
}

function setNameOrId(collection, key, value) {
    let item = collection.find(n => n.key === key);

    if (item) {
        item.value = value;
    } else {
        collection.push({
            key,
            value,
        })
    }
}

const getOurName = function (product) {
    let name = product.names.find(n => n.key === Names.OUR_PRODUCT_NAME);

    return name ? name.value : '';
};

const getOurIdentifier = function (product) {
    let id = product.identifiers.find(i => i.key === Identifiers.PRODUCT_ID);

    return id ? id.value : '';
};

const getSupplierName = function (product) {
    let name = product.names.find(n => n.key === Names.SUPPLIERS_PRODUCT_NAME);

    return name ? name.value : '';
};

const getSupplierIdentifier = function (product) {
    let id = product.identifiers.find(i => i.key === Identifiers.SUPPLIERS_PRODUCT_ID);

    return id ? id.value : '';
};

const getScipName = function (product){
    return getNameOrId(product.names, Names.SCIP_NAME);
};

const getScipId = function (product) {
    return getNameOrId(product.identifiers, Identifiers.SCIP_NUMBER);
};

export {
    SubstanceState,
    ProductType,
    VerificationDocumentType,
    DocumentType,
    Identifiers as ProductIdentifiers,
    Names as ProductNames,
    setNameOrId,
    getSupplierName,
    getSupplierIdentifier,
    getScipName,
    getScipId,
    getNameOrId,
    getOurName,
    getOurIdentifier,
    SubmissionStatus,
    RequestStatus,
    ConcernElementsInformationOwner,
};
